
<template>
  <div class="mt-3">
    <loading
        :active="loading"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>
    <p style="font-weight: 600; color: #53BACA;">Tutores relacionados</p>

    <div class="d-flex justify-content-center w-100">
      <div class="barras d-flex mt-4" style="width: 50%; margin-top: 10px;" >
        <b-form-input class="input-filter" v-model="filter" placeholder="Búsqueda por ID o nombre del tutor" type="text" @keydown.enter.prevent="buscarTutor()" v-on:keypress="esLetra($event)">
        </b-form-input>
        <b-button class="btn-extra-small" variant="info" @click="buscarTutor()">
          <span ><em class="buscar_svg" style="margin-top: 3px; height: 13px;"></em></span>
        </b-button>
      </div>
    </div>

    <div v-if="busquedaActiva" class="d-flex justify-content-center align-items-center flex-column w-100">
      <b-table
          hover
          class="text-center mt-4"
          style="width: 85%"
          :items="tutores"
          :fields="fieldsTutores"
          :per-page="registrosPorPagina"
          :current-page="paginaActual"
          @row-clicked="seleccionarTutor">
      </b-table>
      <b-pagination
          v-if="tutores.length > 6"
          align="center"
          v-model="paginaActual"
          :total-rows="tutores.length"
          :per-page="registrosPorPagina"
      ></b-pagination>
    </div>

    <div class="d-flex justify-content-center align-items-center" v-if="parentescoLocal.idPacientePadre == null && tutorSeleccionado == null" style="min-height: 25vh">
      <p>Sin tutor agregado, por favor busca uno y agregalo</p>
    </div>
    <div v-else class="pl-2 pr-2 mt-5 text-center" style="min-height: 15vh;">
      <b-row style="border-bottom: 1px solid #D3D3D3;">
        <b-col><p class="title">ID del paciente</p></b-col>
        <b-col><p class="title">Nombre del paciente</p></b-col>
        <b-col><p class="title">Parentesco</p></b-col>
        <b-col cols="2" v-if="desaparecerEditar == false"><p class="title">Acciones</p></b-col>
      </b-row>
      <b-row class="mt-2">
        <b-col><p class="body">{{ parentescoLocal.idPacientePadre }}</p></b-col>
        <b-col><p class="body">{{ parentescoLocal.nombrePacientePedre }}</p></b-col>
        <b-col>
          <p class="body" v-if="!parentescoLocal.editar">{{ parentescoLocal.nombreParentesco }}</p>
          <b-form-group v-else>
            <b-form-select
                :options="listadoParentescos"
                text-field="nombre"
                value-field="idParentesco"
                v-model="parentescoLocal.idParentesco"
          ></b-form-select>
          </b-form-group>
      </b-col>
        <b-col cols="2" class="mt-2" v-if="desaparecerEditar == false">
          <em
              v-if="parentescoLocal.editar"
              class="edit_solid_svg"
              @click="desactivarEdicion()"
              style="width: 1.2em; cursor: pointer"
              v-b-tooltip.hover title="Cancelar cambios"
          ></em>
          <em
              v-else-if="!parentescoLocal.editar"
              class="edit_outline_svg"
              @click="activarEdicion()"
              style="width: 1.2em; cursor: pointer"
              v-b-tooltip.hover title="Edición activo"
          ></em>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import {PacienteService} from "@/apiServices/paciente/PacienteService";

export default {
  name: "ContactoPaciente",
  components: {
  },
  props: {
    idPaciente: Number,
    parentesco: Object,
  },
  data: () => ({
    filter: null,
    desaparecerEditar: false,
    loading: false,
    parentescoLocal: null,
    busquedaActiva: false,
    tutorSeleccionado: null,
    listadoParentescos: [],
    registrosPorPagina: 6,
    paginaActual: 1,
    pacienteService: new PacienteService(),
    listaContacto: [],
    fieldsTutores: [
      {
        key: "id",
        label: "ID paciente",
      },
      {
        key: "nombre",
        label: "Nombre persona",
      },
    ],
  }),
  created() {
    this.obtenerListadoParentescos();
    this.parentescoLocal = { ...this.parentesco };
  },
  mounted() {

  },
  watch: {
    parentesco: {
      handler(newValue) {
        this.parentescoLocal = newValue;
        this.parentescoLocal.editar = false;
        this.desaparecerEditar = false;

      },
      deep: true
    },
    "parentescoLocal.idParentesco"() {
      this.$emit("actualizarParentesco", this.parentescoLocal);

    }
  },
  methods: {
    esLetra(e) {
      let char = e.key;
      if (/^[A-Za-zÁÉÍÓÚáéíóúñÑ0-9\s]$/.test(char)) return true;
      else e.preventDefault();
    },
    desactivarEdicion(){
      this.parentescoLocal.idParentesco = this.parentesco.idParentesco;
      this.parentescoLocal.editar = false;
    },
    activarEdicion() {
      this.parentescoLocal.editar = true;
    },
    obtenerListadoParentescos(){
      this.$http
          .get(
              this.$api +
              "paciente/catalogo/listaParentesco"
          )
          .then((response) => {
            if (response.status === 200) {
              this.listadoParentescos = response.data.data;
            }
          }).finally(() =>{
        this.loading = false;
      })
    },
    seleccionarTutor(fila) {
      if(this.parentescoLocal.idPacientePadre != null){
        this.$swal.fire({
          title: "Cambiar de tutor",
          text: "El tutor actual se reemplazará por el seleccionado, ¿desea continuar?",
          icon: "question",
          showCancelButton: true,
          confirmButtonText: "Aceptar",
          cancelButtonText: "Cancelar",
          showLoaderOnConfirm: true,
        }).then((result) => {
          if (result.isConfirmed) {
            this.parentescoLocal.idPacientePadre = fila.id;
            this.parentescoLocal.nombrePacientePedre = fila.nombre;
            this.desaparecerEditar = true;
            this.parentescoLocal.idParentesco = null;
            this.activarEdicion();
            console.log("holaaaaa");
            this.$emit("actualizarParentesco", this.parentescoLocal);
          }else{
            if(this.parentesco != undefined && this.parentesco != null){
              this.parentescoLocal = this.parentesco;
            }else{
              this.parentescoLocal.idPacientePadre = fila.id;
              this.parentescoLocal.nombrePacientePedre = fila.nombre;
              this.desaparecerEditar = true;
              this.parentescoLocal.idParentesco = null;
            }
           
            this.desactivarEdicion();
            this.desaparecerEditar = false;
            console.log("holaaaaa??");
            this.$emit("actualizarParentesco", this.parentescoLocal);
          }
        });
      }else{
        this.parentescoLocal.idPacientePadre = fila.id;
        this.parentescoLocal.nombrePacientePedre = fila.nombre;
        this.desaparecerEditar = true;
        this.parentescoLocal.idParentesco = null;
        this.activarEdicion();
      }
      this.busquedaActiva = false;
      this.filter = null;
    },
    validarInputBusqueda() {
      if (this.filter !== undefined
          && this.filter !== null
          && this.filter !== '') {

        const contieneNumerosLetras =  /[A-Za-z]/.test(this.filter);
        const contieneNumeros = /[0-9]/.test(this.filter);
        return contieneNumerosLetras && contieneNumeros;
      }

      return false;
    },
    buscarTutor(){
      this.loading = true;
      if (this.validarInputBusqueda()) {
        console.error("No se puede buscar por validacion de numeros letras")
        return;
      }
      const datos = {
        datoBuscar: this.filter
      }
      this.$http
          .post(
              this.$api +
              "paciente/perfiles/buscarPacienteMin", datos
          )
          .then((response) => {
            if (response.status === 200) {
              this.tutores = response.data.data;
              this.busquedaActiva = true;
            }
          }).finally(() =>{
        this.loading = false;
      })
    },
  },
};
</script>

<style scoped>
p{
  margin: 0px;
  padding: 0px;
}
.barras {
  border-width: 1px;
  border-style: solid;
  border-color: #c2e7ff;
  background: #ffffff;
  margin-top: 20px;
  /*  margin-right: 3%;*/
  margin-left: 4%;
  padding-right: 2%;
  padding-left: 1%;
  border-radius: 20px;
  text-align: left;
  align-items: center;
}

.btn-extra-small {
  padding: 0.15rem 0.4rem;
  font-size: 0.7rem;
  line-height: 1.5;
}

.title{
  font-size: .9em;
  font-weight: 500;
}

.body{
  font-size: .9em;
  color: #595959;
}
</style>
